import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileUploaderWorkerService {

  public worker: Worker;
  public constructor() {
    this.worker = new Worker('upload-worker.js');
  }

  public postMessage(instructions: any) {
    this.worker.postMessage(instructions);
  }

  public registerWorkerMessageListener(onSaveFileChunk: any, onDeleteFile: any, onCustomErrors: any, onCheckConnectivity: any, onPauseFile: any,onCompleteUpload:any) {
    this.worker.onmessage = async (message: any) => {
      if (message.data?.action === "save") {
        onSaveFileChunk(message);
      } else if (message.data?.action === "delete") {
        onDeleteFile(message);
      } else if (message.data?.action === "custom-errors") {
        onCustomErrors(message);
      } else if (message.data?.action === "check-connectivity") {
        onCheckConnectivity(message);
      } else if (message.data?.action === "pause-file") {
        onPauseFile(message);
      }
      else if (message.data?.action === "on-complete-upload") {
        onCompleteUpload();
      }
    }
  }

  public registerServiceWorker() {
    if ('serviceWorker' in navigator) {
      // Register a service worker
      navigator.serviceWorker.register('upload-worker.js')
        .then(function (registration) {
          //console.log('Service Worker registered successfully:', registration);
        })
        .catch(function (error) {
          console.error('Service Worker registration failed:', error);
        });
    }
  }

  public registerServiceWorkerListener(onRestoreConnection:any) {
    navigator.serviceWorker.onmessage = (event) => {
      if (event.data && event.data.action === 'sync') {
        onRestoreConnection();
      }
    };
  }
}
